
<template>
  <v-btn @click="connect" :loading="loading">
    <v-icon left>{{getSocialiteIcon(driver)}}</v-icon>{{buttonText}}
    <confirm-dialog
      v-if="showExternalLinkDialog"
      :visible="showExternalLinkDialog"
      :title="$t('socialiteConnectButton.external-link-dialog-title')"
      :text="$t('socialiteConnectButton.external-link-dialog-confirm-text', {name: getSocialiteName(driver)})"
      :closeAction="function() {showExternalLinkDialog = false;}"
      :confirmAction="openExternalAccountLinking"
    ></confirm-dialog>
  </v-btn>
</template>

<script>

import socialiteMixin from "@/mixins/socialiteMixin"
import ConfirmDialog from './ConfirmDialog.vue';

export default {
  components: { ConfirmDialog },
  name: "SocialiteConnectButton",
  mixins: [socialiteMixin],
  props: {
    driver: {
      type: String,
      required: true
    }
  },
  data: () => ({
    valid: false,
    loading: false,
    code: undefined,
    showExternalLinkDialog: false,
  }),
  computed: {
    buttonText() {
      return this.$t('socialiteConnectButton.connectWith', {name: this.getSocialiteName(this.driver)})
    }
  },
  methods: {
    connect() {
      if (this.$nativeApp.isIOS()) {
        this.showExternalLinkDialog = true;
        return;
      }
      this.loading = true;
      this.$api
        .authenticateAgainstWebGuard()
        .then(() => {
          this.loading = false;
          window.location = '/auth/' + encodeURIComponent(this.driver) + '/redirect';
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        })
    },
    openExternalAccountLinking() {
      this.showExternalLinkDialog = false;
      this.$common.openExternalLink('https://bit.ly/2PYLexo');
    }
  }
};
</script>